module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tableName":"Table","firstName":"First Name","lastName":"Last Name","createdBy":"Author","labelSearch":"Search changes","refresh":"Refresh"},"de":{"tableName":"Table","firstName":"First Name","lastName":"Last Name","createdBy":"Autor(in)","labelSearch":"Veränderung suchen","refresh":"Refresh"}}')
  delete Component.options._Ctor
}
